import React from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { commaNumber, stripCommas } from "lib/utils/numberFunctions";
import { FormattedMessage, FormattedNumber } from "react-intl";

import { getEntity } from "../../../../data/entity";

import { getCampaign, getCustomFields } from "../../../../data/parent-campaign";

import {
  getDonation,
  getLoading,
  getTotalAmount,
  getFeeAmount,
} from "../../../../data/giving-form/allocation-selection";

import { getBillingType } from "../../../../data/giving-form/billing";

import { nextPage } from "../../../../data/giving-form/routes";
import { updateCustomFields } from "../../../../data/giving-form/allocation-selection";

import ThankYouForm from "../components/ThankYouForm";

import { displayOnStep } from "../utils";

import classNames from "classnames";

export class ThankYou extends React.Component {
  static propTypes = {
    onCloseModal: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
    totalAmount: PropTypes.number,
    availableVotes: PropTypes.number,
    billingType: PropTypes.string,
    shareLink: PropTypes.string,
    customFields: PropTypes.instanceOf(Immutable.List).isRequired,
  };

  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };

  handleFBShare = (e) => {
    const shareLink = this.props.shareLink ? this.props.shareLink : window.location.href;

    e.preventDefault();
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${shareLink}`,
      "pop",
      "width=600, height=400, scrollbars=no",
    );
  };

  hasCustomFields(customFields) {
    return customFields.find((cf) => displayOnStep(cf.get("display_on_step")));
  }

  handleSubmit = (e) => {
    const { customFields } = this.props;
    const { submit, nextPage } = this.props;

    e.preventDefault();

    //Skip over submitting through redux forms if no custom fields
    if (this.hasCustomFields(customFields)) {
      submit("thank-you");
    } else {
      nextPage();
    }
  };

  handleCustomFields = (values) => {
    const { campaignId, donationId, updateCustomFields } = this.props;

    return updateCustomFields({
      campaignId,
      donationId,
      customFields: values,
    });
  };

  componentDidMount() {
    window &&
      window.SnapAnalytics &&
      window.SnapAnalytics.track({
        hitType: "event",
        eventCategory: "giving form",
        eventAction: "donationFormThankYou",
      });
  }

  renderGift() {
    const { entity } = this.props;

    if (entity.get("gift_confirmation_text")) {
      const html = { __html: entity.get("gift_confirmation_text") };

      return <div className="text-center" dangerouslySetInnerHTML={html} />;
    }
  }

  render() {
    const {
      totalAmount,
      billingType,
      customFields,
      isLoading,
      entity,
      feeAmount,
      currencyCode,
    } = this.props;

    const finalAmount = (
      parseFloat(stripCommas(totalAmount)) + parseFloat(stripCommas(feeAmount))
    ).toFixed(2);

    return (
      <section className="Modal__Content donate-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-giving-form--ThankYo-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              <FormattedMessage id="thankYou" />
            </h2>
            <span className="white-font-color">
              <FormattedMessage id="allSet" />
            </span>
            <br />
            <span className="white-font-color">
              <FormattedMessage id="receiveEmail" />
            </span>
          </div>
          <div className="voting-modal-body">
            <div className="voting-modal-body-inside">
              <div className="donating-amount-area">
                <h4>
                  <strong>Your gift amount:</strong>
                </h4>
                <div className="white-bg p-md-a f-2x">
                  <span>
                    <FormattedNumber
                      value={finalAmount}
                      style="currency"
                      currencyDisplay="symbol"
                      currency={currencyCode}
                    />
                  </span>
                </div>
                <div className="m-sm-t">That was a {billingType || "one-time"} gift</div>
              </div>

              {this.renderGift()}
              <h3 className="text-center">Share</h3>
              <div className="p-sm-t text-center">
                <i
                  className="fa fa-3x fa-brands fa-square-facebook fb-font-color pointer"
                  onClick={this.handleFBShare}
                />
              </div>
            </div>
          </div>

          <div>
            <button
              data-testid="t-giving-form--ThankYo-button-2"
              className="voting-modal-btn secondary-color-background"
              onClick={this.handleSubmit}
              title="donation-complete"
              disabled={isLoading}>
              {isLoading === true ? (
                <i className="fa fa-2x fa-spin fa-refresh" />
              ) : (
                <FormattedMessage id="returnToSite" />
              )}
            </button>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  campaignId: getCampaign(state)("giving_form").get("id"),
  donationId: getDonation(state),
  isLoading: getLoading(state),
  shareLink: getEntity(state).get("entityShareLink"),
  billingType: getBillingType(state),
  customFields: getCustomFields(state)("giving_form"),
  totalAmount: getTotalAmount(state),
  entity: getEntity(state),
  feeAmount: getFeeAmount(state),
});

const mapActionCreators = {
  submit,
  updateCustomFields,
  nextPage,
};

export default connect(mapStateToProps, mapActionCreators)(ThankYou);
